import {IntlShape} from "react-intl";
import {ModalProps} from "peggirkit/dist/components/Modal/Modal";
import {ConfirmModalProps} from "peggirkit/dist/components/Modal/ConfirmModal/ConfirmModal";


export const globalModalProps = (): Pick<ModalProps, "position" | "breakpoints"> => ({
    position: "center-bottom",
    breakpoints: {
        md: {
            position: "center",
        },
    },
});

export const globalConfirmModalProps = (
    intl: IntlShape,
): Pick<ConfirmModalProps, "dismissButton" | "position" | "breakpoints"> => ({
    ...globalModalProps(),
    dismissButton: {
        text: intl.formatMessage({id: "cancel"}),
    },
});